mutation UpdateCompetitorIqWebsiteSettings($input: CompetitorIqWebsitesSettingsInput!) {
    competitorIqWebsitesSettingsSet(input: $input) {
        website
        competitors
    }
}
